  <template>
    <div class="photo-component">
      <img v-if="imageUrl" :src="imageUrl" :alt="altText">
    </div>
  </template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    altText: {
      type: String,
      default: 'zdjęcie lawety'
    }
  }
}
</script> 

<style scoped lang="scss">
.photo-component {
  width: 100%;
  height: 100%;
  background-color: $color-white;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>